export default __webpack_public_path__ + "static/header-iconic-link-developers-icon1.url-77d3e09375616ff82de859f14961bd1e.svg";